"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GroupsAndClassesSelection = void 0;
var _react = require("react");
var _GroupsAndClassesSelection = require("./GroupsAndClassesSelection.styles");
var _hooks = require("../../../../../hooks");
var _AudiencePicker = require("../../../AudiencePicker.labels");
var _Tabs = require("../../../../../UI/Tabs");
var _Button = require("../../../../../UI/Button");
var _AudienceSelectList = require("../AudienceSelectList");
var _SelectedAudience = require("../SelectedAudience");
var _CetComponentsProvider = require("../../../../../providers/CetComponentsProvider");
var _cetEnvironment = require("../../../../../utilities/cetEnvironment");
var _jsxRuntime = require("react/jsx-runtime");
const GroupsAndClassesSelection = props => {
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const {
    isReadOnly,
    setGroupType,
    groupType,
    classesIds,
    groupsIds,
    setViewAndIndex,
    setCreateGroupTempData,
    setStudentsSelectorTempData,
    environmentID,
    selectedStudentsIds,
    groupsSelectorTempData
  } = props;
  const styles = (0, _GroupsAndClassesSelection.useStyles)(props);
  const getLabel = (0, _hooks.useLabels)({
    labels: _AudiencePicker.labels
  });
  const [tabs, setTabs] = (0, _react.useState)([]);
  const {
    language
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  (0, _react.useEffect)(() => {
    setGroupType('classes');
  }, [setGroupType]);
  (0, _react.useEffect)(() => {
    let _tabs = [];
    if (classesIds && classesIds.length > 0) {
      _tabs.push({
        id: 'classes',
        label: `${getLabel('groupsSelectListTools_class')}${isMobileView && groupsSelectorTempData?.selectedClassesIds.length ? ' (' + groupsSelectorTempData?.selectedClassesIds.length + ')' : ''}`
      });
    }
    if (groupsIds && groupsIds.length > 0) {
      _tabs.push({
        id: 'groups',
        label: `${getLabel('groupsSelectListTools_groups')}${isMobileView && groupsSelectorTempData?.selectedGroupsIds.length ? ' (' + groupsSelectorTempData?.selectedGroupsIds.length + ')' : ''}`
      });
    }
    setTabs(_tabs);
  }, [classesIds, getLabel, groupsIds, groupsSelectorTempData?.selectedClassesIds.length, groupsSelectorTempData?.selectedGroupsIds.length, isMobileView]);
  const {
    userId,
    role,
    schoolId: sessionSchoolId
  } = (0, _hooks.useSessionData)();
  const handleTabClick = tab => {
    setGroupType(tab.id);
  };
  const defaultStudentsSelectorTempData = {
    groupSearchText: '',
    isGroupSearchOpen: false,
    studentsSearchText: '',
    isStudentsSearchOpen: false,
    selectedGroup: environmentID ? 'all' : classesIds && classesIds.length > 0 ? classesIds[0] : groupsIds && groupsIds.length > 0 ? groupsIds[0] : ''
  };
  const handleCreateGroupClick = () => {
    setStudentsSelectorTempData({
      selectedStudentsIds: [...[]],
      ...defaultStudentsSelectorTempData
    });
    setCreateGroupTempData({
      groupName: '',
      groupId: null
    });
    setViewAndIndex('createGroup', 0);
  };
  const handleSingleStudentsClick = () => {
    setStudentsSelectorTempData({
      selectedStudentsIds: [...(selectedStudentsIds || [])],
      ...defaultStudentsSelectorTempData
    });
    setViewAndIndex('studentsSelector', 0);
  };
  const handleGroupNotFoundClick = () => {
    const cetDomain = (0, _cetEnvironment.getCetEnvironmentInfo)().cetDomain;
    //  language = 'ar' | 'he' | 'en';
    const userManagementUrl = `https://${language === 'ar' ? 'ar.' : ''}ofek.${cetDomain}/SchoolManager/MemberData.aspx`;
    window.open(`${userManagementUrl}?gGroupID=${sessionSchoolId}&gMemberID=${userId}&sRole=teacher&From=ofek`);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-AudiencePicker__groups-and-classes-selection'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SelectedAudience.SelectedAudience, {
      ...props,
      selectedStudentsIds: isMobileView ? [] : selectedStudentsIds,
      audienceType: groupType || 'classes'
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: styles['cc-AudiencePicker__groups-and-classes-selection__list'],
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: styles['cc-AudiencePicker__groups-and-classes-selection__list-header'],
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: styles['cc-AudiencePicker__groups-and-classes-selection__list-header__tabs'],
          children: tabs.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tabs.Tabs, {
            id: "groupsAndClassesSelection",
            tabs: tabs,
            onTabClick: handleTabClick
          })
        }), !isReadOnly && !isMobileView && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: styles['cc-AudiencePicker__groups-and-classes-selection__list-header__buttons'],
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
            id: "newGroupButton",
            size: "small",
            view: "alternate",
            color: "primary",
            shape: "roundedRectangle",
            category: "assignActivity",
            label: "newGroup",
            onClick: handleCreateGroupClick,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
              children: getLabel('groupsSelectListTools_newGroup')
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
            id: "singleStudentsButton",
            size: "small",
            view: "alternate",
            color: "primary",
            shape: "roundedRectangle",
            category: "assignActivity",
            label: "singletStudents",
            onClick: handleSingleStudentsClick,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
              children: getLabel('groupsSelectListTools_students')
            })
          }), role?.toLowerCase() === 'teacher' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
            id: "GroupNotFoundButton",
            size: "small",
            view: "alternate",
            color: "primary",
            shape: "roundedRectangle",
            category: "assignActivity",
            label: "groupNotFound",
            onClick: handleGroupNotFoundClick,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
              children: getLabel('groupsSelectListTools_groupNotFound')
            })
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_AudienceSelectList.AudienceSelectList, {
        ...props,
        audienceType: groupType || 'classes'
      })]
    })]
  });
};
exports.GroupsAndClassesSelection = GroupsAndClassesSelection;